// PiP 창을 키우기 위한 계산 (순수 함수).
// Chrome은 Document PiP 창을 그 모니터 작업 영역의 80%까지만 허용한다(그보다 크게 요청하면 브라우저가 임의로 줄인다).
// 그래서 "최대화"는 모니터 전체가 아니라 허용되는 최대 크기(80%)를 그 모니터 가운데에 놓는 것이다.

export const PIP_MAX_RATIO = 0.8;

/** screen(그 창의 window.screen): 작업 표시줄을 뺀 사용 가능 영역(avail*)을 쓰고, 없으면 화면 전체 크기와 0,0이다. */
export function maximizeTarget(screen) {
  const availLeft = screen.availLeft ?? 0;
  const availTop = screen.availTop ?? 0;
  const availWidth = screen.availWidth ?? screen.width;
  const availHeight = screen.availHeight ?? screen.height;
  const width = Math.floor(availWidth * PIP_MAX_RATIO);
  const height = Math.floor(availHeight * PIP_MAX_RATIO);
  return {
    left: availLeft + Math.floor((availWidth - width) / 2),
    top: availTop + Math.floor((availHeight - height) / 2),
    width,
    height,
  };
}

/** 창 크기(width/height)가 목표와 거의 같으면(창 테두리 오차 tolerance px 이내) 이미 최대 크기다. */
export function isMaximized(size, target, tolerance = 12) {
  return Math.abs(size.width - target.width) <= tolerance && Math.abs(size.height - target.height) <= tolerance;
}

/** 키우려 했는데 가로나 세로가 오히려 줄었는가(브라우저가 요청을 엉뚱하게 줄인 경우). 1~2px 오차는 무시한다. */
export function shrunk(before, after, tolerance = 2) {
  return after.width < before.width - tolerance || after.height < before.height - tolerance;
}
